module.exports = __webpack_public_path__ + "img/Case_Study.c9f8d18f.jpg";